<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/report-user/new">Report user management</a></li>
              <li class="breadcrumb-item active">Report user link management</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title *ngIf="!id" -->
    <div class="row">
      <div class="col-12">

        <div class="card-box">



          <form class="row form-horizontal" role="form" autocomplete="off">

            <div class="col-md-6 form-horizontal px-3">

              <div class="row">
                <div class="col-12">
                  <div class="card-box text-center">
                    <h3>User Profile</h3>
                    <p class="sub-header">
                      {{UserName}}
                    </p>
                    <div class="header-icon-container"><i class="fe-user header-icon"></i></div>
                    <p class="sub-header">
                      {{name}} {{lastName}}
                    </p>
                    <p class="sub-header">
                      {{lastLogin | date}}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <h4>User Merchants links</h4>
                </div>
              </div>

              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width:100%">
                <thead>
                  <tr>
                    <th>Merchant </th>
                    <th>No. of terminals</th>
                    <th class="text-right" colspan="2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let merchant of merchantreports">
                    <td>{{ merchant.usnNumber }}</td>
                    <td>{{ merchant.noOfTerminals }}</td>
                    <td colspan="2">
                      <button type="button" *ngIf="canManage" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="viewTerminals(merchant)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        view terminals
                      </button>
                    </td>
                    <td>
                      <button type="button" *ngIf="canManage" class="btn btn-danger waves-effect waves-light fa-pull-right" (click)="openDeleteConfirmDialog(merchant)">
                        <i class="mdi mdi-delete-outline"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="merchants?.length == 0">
                  <tr>
                    <td colspan="4" class="no-data-available">No merchants available to display!</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-6 form-horizontal px-3">
              <div class="form-group row">
                <div class="col-9">
                  <label>Viewing merchants for participant: {{defaultParticipant}}</label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-9">
                  <label>Select a Merchant to link to a user profile</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="globalSearch" (change)="globalMerchantSearch($event)" [(ngModel)]="globalSearch" placeholder="Global search">&nbsp;Global search
                </div>
                <br />
              </div>
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width:100%">
                <thead>
                  <tr>
                    <th>USN Number</th>
                    <th>Merchant number</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let merchant of merchants">
                    <td>{{ merchant.usnNumber }}</td>
                    <td>{{ merchant.merchantNumber }}</td>
                    <td>
                      <button type="button" *ngIf="canManage" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="linkMerchant(merchant)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        link merchant
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="merchants?.length == 0">
                  <tr>
                    <td colspan="6" class="no-data-available">No merchants available to display!</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </form>
        </div>

        <div class="form-group row offset-3 col-9" *ngIf="!!registerResult && registerResult.success == false">
          <ng-container *ngIf="!!registerResult.message">
            <p class="text-danger">{{registerResult.message}}</p>
          </ng-container>
          <ng-container *ngIf="!!registerResult.identityResult">
            <ng-container *ngFor="let error of registerResult.identityResult.errors">
              <p class="col-12 text-danger">{{error.description}}</p>
            </ng-container>
          </ng-container>
        </div>

        <div class="form-group row float-right">
          <div class="col-12">
            <button type="submit" style="width:80px" class="btn btn-info waves-effect waves-light" (click)="save()"><i class="mdi mdi-content-save"></i>Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
